/*
 *  TTTech nerve-management-system-frontend
 *  Copyright(c) 2026. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */
import { defineStore } from 'pinia';

const DRAWER_STATE_STORAGE_KEY = 'iiot.drawer.isOpen.v1';

const getInitialDrawerState = () => {
  try {
    const rawDrawerState = localStorage.getItem(DRAWER_STATE_STORAGE_KEY);
    if (rawDrawerState === null) return true;

    const parsedDrawerState = JSON.parse(rawDrawerState);
    return typeof parsedDrawerState === 'boolean' ? parsedDrawerState : true;
  } catch {
    return true;
  }
};

const persistDrawerState = (isOpen) => {
  localStorage.setItem(DRAWER_STATE_STORAGE_KEY, JSON.stringify(isOpen));
};

const useAppStore = defineStore('app', {
  state: () => ({
    drawer: getInitialDrawerState(),
  }),
  actions: {
    setDrawer(isOpen) {
      this.drawer = !!isOpen;
      persistDrawerState(this.drawer);
    },

    async toggleDrawer() {
      this.setDrawer(!this.drawer);
    },
  },
});

export default useAppStore;
